'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SVGContainer = require('../SVGContainer');

var _SVGContainer2 = _interopRequireDefault(_SVGContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CursorArrowIcon = function CursorArrowIcon(props) {
  return _react2.default.createElement(
    _SVGContainer2.default,
    props,
    _react2.default.createElement('polygon', { points: '19.023136 28 21.9556387 26.4079631 17.3461532 17.6076021 23.3333333 17.6076021 10 4 10 22.9284908 14.2032589 18.7968216' })
  );
};

CursorArrowIcon.propTypes = {
  size: _react.PropTypes.oneOf(['small', 'medium', 'large'])
};

exports.default = CursorArrowIcon;